import React, { useState } from 'react';
import { DashboardLayout } from '../../components/layouts';
import { SiteList } from '../../components/parts';
import styles from './style.module.css';

export default function Facility() {
  const [selects, setSelects] = useState({
    region: '',
    subsidiary: '',
    subholding: '',
  });

  function onSelected(payload) {
    if (payload.target.id === 'filter-region') {
      setSelects({ ...selects, region: payload.target.value });
    }
    if (payload.target.id === 'filter-subsidiary') {
      setSelects({ ...selects, subsidiary: payload.target.value });
    }
    if (payload.target.id === 'filter-subholding') {
      setSelects({ ...selects, subholding: payload.target.value });
    }
    // console.log(props.target.value)
  }

  return (
    <DashboardLayout>
      <div className={styles.root}>
        <h1 className={styles.pageTitle}>Pilihan Fasilitas</h1>
        <h3 className={styles.pageSubtitle}>Filter</h3>
        <SiteList onSelected={onSelected} selects={selects} />
      </div>
    </DashboardLayout>
  );
}
